import { useQuery } from "@tanstack/react-query";
import axios from "const/axios";

/** Tab badges and dues change from other screens, so a stale summary reloads when the client opens. */
export const useClientSummary = (clientId) =>
  useQuery({
    queryKey: ["client-summary", clientId],
    queryFn: async () => {
      const res = await axios.get(`clients/${clientId}/summary`);
      return res.data?.data ?? res.data;
    },
    enabled: !!clientId,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
